module.exports = __webpack_public_path__ + "static/media/Vipul_portrait.77662110.jpg";